// extracted by mini-css-extract-plugin
module.exports = {"button":"PreviewMessage_button___Vg3Y","water":"PreviewMessage_water__B4ZE3","rotate":"PreviewMessage_rotate__9ulMW","pulsate":"PreviewMessage_pulsate__YEtz8"};